import { Tooltip, Typography } from '@deeptrue-frontend/ui';
import React from 'react';
import styled from 'styled-components/macro';

interface ActivationElementProps {
  value: number;
  label: string;
  tooltip: string;
}

const Wrapper = styled.div`
  margin-top: 1.5rem;
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
`;

const Element = styled.div`
  width: 100%;
  background-color: #dee2ed;
  border-radius: 5px;
`;

const Fill = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  height: 0.5rem;
  background-color: #1656e9;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
`;

const Value = styled(Typography)`
  font-weight: 700;
  font-size: 0.875rem;
  color: #253858;
  margin-right: 0.5rem;
`;

const Text = styled(Typography)`
  font-weight: 400;
  font-size: 0.875rem;
  color: #253858;
  margin-right: 0.34rem;
`;

const ActivationElement = ({
  value,
  label,
  tooltip,
}: ActivationElementProps) => {
  return (
    <Wrapper>
      <Label>
        <Value>{value}%</Value>
        <Text>{label}</Text>
        <Tooltip text={tooltip} />
      </Label>
      <Element>
        <Fill width={value} />
      </Element>
    </Wrapper>
  );
};

export default ActivationElement;
